<div class="modal-overlay wizard-overlay" *ngIf="isVisible" [class.active]="isVisible">
  <div class="modal wizard-modal">

    <!-- <div class="terms-loader-overlay" *ngIf="isSubmitting">
      <app-embedded-loader [show]="isSubmitting" message="Uploading signature and submitting..."></app-embedded-loader>
    </div> -->
    <div class="global-loader-overlay" *ngIf="isSubmitting">
      <div class="global-loader-box">
        <mat-spinner diameter="50"></mat-spinner>
        <!-- <p>Uploading signature and submitting...</p> -->
         <p>{{loadingMsg}}</p>
      </div>
    </div>

    <!-- Wizard Header -->
    <div class="wizard-header">
      <div class="wizard-header-top">
        <h3 class="wizard-title">
          <mat-icon>verified_user</mat-icon>
          Terms & Conditions Setup
        </h3>
        <span class="wizard-step-counter">Step {{ currentStep + 1 }} of {{ totalSteps }}</span>
      </div>

      <!-- Stepper -->
      <div class="stepper">
        <ng-container *ngFor="let i of stepIndices">
          <div class="stepper-node-wrap">
            <button
              type="button"
              class="stepper-node"
              [class.active]="i === currentStep"
              [class.completed]="i < currentStep"
              (click)="goToStep(i)"
              [attr.aria-label]="'Go to step ' + (i + 1)">
              <mat-icon *ngIf="i < currentStep">check</mat-icon>
              <span *ngIf="i >= currentStep">{{ i + 1 }}</span>
            </button>
            <span class="stepper-label">
              <ng-container [ngSwitch]="true">
                <ng-container *ngSwitchCase="i === 0">Welcome</ng-container>
                <ng-container *ngSwitchCase="i >= 1 && i <= documents.length">{{ documents[i-1]?.tabLabel }}</ng-container>
                <ng-container *ngSwitchCase="i === documents.length + 1">Identity & Signature</ng-container>
                <ng-container *ngSwitchCase="i === documents.length + 2">Review & Submit</ng-container>
              </ng-container>
            </span>
          </div>
          <!-- <div class="stepper-connector" *ngIf="i < totalSteps - 1" [class.completed]="i < currentStep"></div> -->
          <div class="stepper-arrow" *ngIf="i < totalSteps - 1" [class.completed]="i < currentStep">
            &gt;
          </div>
        </ng-container>
      </div>

      <!-- Progress bar (mobile fallback) -->
      <div class="wizard-progress-bar">
        <div class="wizard-progress-fill" [style.width.%]="progressPercent"></div>
      </div>
    </div>

    <!-- Wizard Body -->
    <div class="wizard-body">

      <!-- ===== STEP 0: WELCOME ===== -->
      <div class="wizard-step" *ngIf="isWelcomeStep">
        <div class="welcome-hero">
          <div class="welcome-icon">
            <mat-icon>waving_hand</mat-icon>
          </div>
          <h2>Welcome{{ fullName ? ', ' + fullName : '' }}!</h2>
          <p class="welcome-subtitle">
            Before you start using the VSMPS Portal, we need you to review and sign the following documents.
            This guided setup will walk you through each step.
          </p>
        </div>

        <div class="welcome-checklist">
          <h4>You'll be asked to:</h4>
          <ul>
            <li *ngFor="let doc of documents; let i = index">
              <mat-icon>description</mat-icon>
              <div>
                <div class="checklist-title">Review {{ doc.tabLabel }}</div>
                <!-- <div class="checklist-sub">{{ doc.subtitle }}</div> -->
              </div>
            </li>
            <li>
              <mat-icon>edit</mat-icon>
              <div>
                <div class="checklist-title">Provide identity & signature</div>
                <div class="checklist-sub">Type your full name and draw or upload a signature image</div>
              </div>
            </li>
            <li>
              <mat-icon>task_alt</mat-icon>
              <div>
                <div class="checklist-title">Review & submit</div>
                <div class="checklist-sub">Confirm your acceptance of all documents</div>
              </div>
            </li>
          </ul>
        </div>

        <div class="welcome-note">
          <mat-icon>info</mat-icon>
          <span>It usually takes 3–5 minutes. You can navigate between steps using Back/Next.</span>
        </div>
      </div>

      <!-- ===== STEPS 1..N: DOCUMENT REVIEW ===== -->
      <div class="wizard-step" *ngIf="isDocumentStep && currentDocument as doc">
        <div class="step-heading">
          <div>
            <h2>{{ doc.title }}</h2>
            <!-- <p class="step-sub">{{ doc.subtitle }}</p> -->
          </div>
          <span class="doc-progress-pill">Document {{ currentStep }} of {{ documents.length }}</span>
        </div>

        <div class="pdf-viewer-section">
          <div class="pdf-viewer-header">
            <div class="pdf-viewer-title">
              <mat-icon>picture_as_pdf</mat-icon>
              <span>{{ doc.title }}</span>
            </div>
          </div>
          <div class="pdf-viewer-body">
            <pdf-viewer
              [src]="doc.url"
              [render-text]="false"
              [page]="1"
              [show-all]="true"
              [original-size]="false"
              class="pdf-viewer-content">
            </pdf-viewer>
          </div>
        </div>

        <label class="ack-checkbox">
          <input type="checkbox" [(ngModel)]="doc.acknowledged" name="ack-{{ doc.id }}" />
          <span class="ack-text">
            I have read and understood the <strong>{{ doc.title }}</strong>.
          </span>
        </label>
      </div>

      <!-- ===== STEP N+1: IDENTITY & SIGNATURE ===== -->
      <div class="wizard-step" *ngIf="isSignatureStep">
        <div class="step-heading">
          <div>
            <h2>Identity & Signature</h2>
            <p class="step-sub">Provide your full name and draw or upload an image of your signature.</p>
          </div>
        </div>

        <form [formGroup]="signatureForm" (ngSubmit)="$event.preventDefault()">
          <div class="form-row">
            <div class="form-group">
              <label for="userFullName">Full Name *</label>
              <input
                id="userFullName"
                type="text"
                class="form-control"
                placeholder="Please enter full name"
                formControlName="userFullName" />
              <small class="field-error"
                *ngIf="signatureForm.get('userFullName')?.invalid && signatureForm.get('userFullName')?.touched">
                Full name is required
              </small>
            </div>

            <div class="form-group">
              <label for="userDesignation">Designation *</label>
              <input
                id="userDesignation"
                type="text"
                class="form-control"
                placeholder="e.g. Procurement Manager"
                formControlName="userDesignation" />
              <small class="field-error"
                *ngIf="signatureForm.get('userDesignation')?.invalid && signatureForm.get('userDesignation')?.touched">
                Designation is required
              </small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="userCompanyName">Company *</label>
              <input
                id="userCompanyName"
                type="text"
                class="form-control"
                placeholder="Enter company name"
                formControlName="userCompanyName" />
              <small class="field-error"
                *ngIf="signatureForm.get('userCompanyName')?.invalid && signatureForm.get('userCompanyName')?.touched">
                Company is required
              </small>
            </div>

            <div class="form-group">
              <label>Country *</label>
              <div class="country-autocomplete-wrap">
                <app-paginated-autocomplete
                  [displayWithFunc]="filterFieldCountryNameDisplayFn"
                  [dataSrc]="boundGetCountryAutoComplete"
                  [controlName]="'country'"
                  [control]="getAddressCountryControl()"
                  [placeholder]="'Select country'"
                  [label]="''"
                  [readonly]="false"
                  (autoCompleteOptionSelected)="onCountrySelected($event)">
                </app-paginated-autocomplete>
              </div>
              <small class="field-error"
                *ngIf="signatureForm.get('country')?.invalid && signatureForm.get('country')?.touched">
                Country is required
              </small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="controllerName">Controller Name *</label>
              <input
                id="controllerName"
                type="text"
                class="form-control"
                placeholder="Enter controller name"
                formControlName="controllerName" />
              <small class="field-error"
                *ngIf="signatureForm.get('controllerName')?.invalid && signatureForm.get('controllerName')?.touched">
                Controller Name is required
              </small>
            </div>

              <div class="form-group">
                <label for="controllerAddress">Controller Address *</label>
                <textarea
                  id="controllerAddress"
                  type="text"
                  class="form-control"
                  placeholder="Enter controller address"
                  formControlName="controllerAddress"
                  ></textarea>
                
                <small class="field-error"
                  *ngIf="signatureForm.get('controllerAddress')?.invalid && signatureForm.get('controllerAddress')?.touched">
                  Controller Address is required
                </small>
              </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="currentDate">Date *</label>
              <input
                id="date"
                type="date"
                class="form-control"
                formControlName="currentDate"
                readonly />
            </div>
            <div class="form-group"><!-- spacer --></div>
          </div>

          <div class="form-group">
            <label>Signature *</label>

            <mat-tab-group
              class="sig-tabs"
              [selectedIndex]="signatureTabIndex"
              (selectedIndexChange)="onSigTabChange($event)"
              animationDuration="0ms"
              mat-stretch-tabs="false">

              <!-- ===== DRAW TAB ===== -->
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="sig-tab-icon">edit</mat-icon>
                  <span class="sig-tab-label">Draw</span>
                </ng-template>

                <div class="sig-draw-pad" [class.has-ink]="hasDrawn">
                  <canvas
                    #signatureCanvas
                    class="sig-canvas"
                    aria-label="Signature drawing area"
                    role="img"
                    tabindex="0">
                  </canvas>
                  <div class="sig-empty-hint" *ngIf="!hasDrawn">Sign here</div>
                </div>

                <div class="sig-actions">
                  <button
                    type="button"
                    class="wizard-btn ghost sig-btn-sm"
                    (click)="clearPad()"
                    [disabled]="isSubmitting || !hasDrawn">
                    <mat-icon>refresh</mat-icon>
                    Clear
                  </button>
                  <button
                    type="button"
                    class="wizard-btn primary sig-btn-sm"
                    (click)="commitDrawnSignature()"
                    [disabled]="!hasDrawn || isSubmitting">
                    <mat-icon>check</mat-icon>
                    Use this signature
                  </button>
                </div>

                <p class="sig-tip">
                  <mat-icon>info_outline</mat-icon>
                  Use mouse or finger to sign. Tap Clear to redo.
                </p>

                <small class="field-error" *ngIf="drawError">{{ drawError }}</small>
              </mat-tab>

              <!-- ===== UPLOAD TAB ===== -->
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="sig-tab-icon">cloud_upload</mat-icon>
                  <span class="sig-tab-label">Upload</span>
                </ng-template>

                <div
                  class="file-upload"
                  [class.drag-active]="dragActive"
                  (click)="triggerFileBrowse(fileInput)"
                  (dragover)="onDragOver($event)"
                  (dragleave)="onDragLeave()"
                  (drop)="onDrop($event)">
                  <i class="fas fa-cloud-upload-alt"></i>
                  <p>Click to upload or drag and drop a file</p>
                  <p style="font-size: 14px; margin-top: 5px;">JPG, JPEG, PNG up to 10MB</p>
                </div>
                <input #fileInput type="file" accept=".jpg,.jpeg,.png" style="display: none;" (change)="onFileChange($event)" />
              </mat-tab>
            </mat-tab-group>

            <!-- Committed signature preview — visible regardless of active tab so the user always sees what will be submitted. -->
            <div class="file-list" *ngIf="uploadedFiles.length">
              <div class="file-item" *ngFor="let file of uploadedFiles; let i = index">
                <div class="file-header">
                  <div>
                    <mat-icon class="sig-source-icon" *ngIf="signatureSource === 'draw'">edit</mat-icon>
                    <mat-icon class="sig-source-icon" *ngIf="signatureSource === 'upload'">image</mat-icon>
                    {{ file.name }} ({{ file.displaySize }})
                  </div>
                  <button type="button" class="remove-file" (click)="removeFile(i)" [disabled]="isSubmitting">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
                <img *ngIf="file.dataUrl" [src]="file.dataUrl" class="file-preview" alt="signature preview" />
              </div>
            </div>
          </div>

          <div class="info-note">
            <mat-icon>info_outline</mat-icon>
            <span>Formal acknowledgement is required. Please type your full name and upload an image of your signature.</span>
          </div>
        </form>
      </div>

      <!-- ===== STEP N+2: FINAL REVIEW ===== -->
      <div class="wizard-step" *ngIf="isReviewStep">
        <!-- <app-embedded-loader [show]=true></app-embedded-loader> -->
        <div class="step-heading">
          <div>
            <h2>Review & Submit</h2>
            <p class="step-sub">Please review your details before submitting.</p>
          </div>
        </div>

        <div class="review-card">
          <h4 class="review-section-title">Documents acknowledged</h4>
          <ul class="review-doc-list">
            <li *ngFor="let doc of documents">
              <mat-icon class="ok-icon" *ngIf="doc.acknowledged">check_circle</mat-icon>
              <mat-icon class="warn-icon" *ngIf="!doc.acknowledged">error</mat-icon>
              <div>
                <div class="review-doc-title">{{ doc.title }}</div>
                <div class="review-doc-sub">{{ doc.title }}</div>
              </div>
              <span class="review-doc-status" [class.ok]="doc.acknowledged" [class.warn]="!doc.acknowledged">
                {{ doc.acknowledged ? 'Acknowledged' : 'Pending' }}
              </span>
            </li>
          </ul>
        </div>

        <div class="review-card">
          <h4 class="review-section-title">Identity & Signature</h4>
          <div class="review-grid">
            <div class="review-field">
              <span class="review-label">Full Name</span>
              <span class="review-value">{{ signatureForm.get('userFullName')?.value || '—' }}</span>
            </div>
            <div class="review-field">
              <span class="review-label">Designation</span>
              <span class="review-value">{{ signatureForm.get('userDesignation')?.value || '—' }}</span>
            </div>
            <div class="review-field">
              <span class="review-label">Company</span>
              <span class="review-value">{{ signatureForm.get('userCompanyName')?.value || '—' }}</span>
            </div>
            <div class="review-field">
              <span class="review-label">Country</span>
              <span class="review-value">{{ selectedCountry?.name || '—' }}</span>
            </div>
            <div class="review-field">
              <span class="review-label">Date</span>
              <span class="review-value">{{ currentDate }}</span>
            </div>
          </div>
          <div class="review-signature" *ngIf="uploadedFiles.length">
            <span class="review-label">Signature</span>
            <img *ngIf="uploadedFiles[0]?.dataUrl" [src]="uploadedFiles[0].dataUrl" class="file-preview" alt="signature preview" />
          </div>
        </div>

        <div class="info-note">
          <mat-icon>verified</mat-icon>
          <span>By clicking <strong>Confirm & Submit</strong> you accept all documents listed above.</span>
        </div>
      </div>

    </div>

    <!-- Wizard Footer / Navigation -->
    <div class="wizard-footer">
      <button class="wizard-btn ghost" type="button" (click)="prevStep()" [disabled]="currentStep === 0 || isSubmitting">
        <mat-icon>arrow_back</mat-icon>
        Back
      </button>

      <div class="wizard-footer-right">
        <button
          *ngIf="!isReviewStep"
          class="wizard-btn primary"
          type="button"
          (click)="nextStep()"
          [disabled]="!canGoNext() || isSubmitting">
          Next
          <mat-icon>arrow_forward</mat-icon>
        </button>

        <button
          *ngIf="isReviewStep"
          class="wizard-btn submit"
          type="button"
          (click)="acceptTerms()"
          [disabled]="isSubmitting">
          <mat-icon>check_circle</mat-icon>
          {{ isSubmitting ? 'Submitting...' : 'Confirm & Submit' }}
        </button>
      </div>
    </div>
  </div>
</div>


<!-- Success popup (unchanged) -->
<div class="modal-overlay" [class.active]="showTermsSuccessPopup" *ngIf="showTermsSuccessPopup">
  <div class="successModal">
    <div class="success-icon">🎉</div>
    <h2>Welcome to VSMPS Portal!</h2>
    <p>Thank you for signing the Terms and Conditions. Your agreement has been successfully recorded.</p>
    <p>You are now verified and granted full access to your dashboard.</p>
    <p>Welcome aboard — you can now manage your marine supply activities seamlessly.</p>
    <button class="success-btn" (click)="proceed()">Proceed to Dashboard</button>
  </div>
</div>
